import React from 'react';
import { SelectDivider } from '../Select.Divider';
import { SelectLabel } from '../Select.Label';
import styles from './Select.Section.scss';
export var SelectSection = function SelectSection(props) {
  return React.createElement("div", null, React.createElement(SelectDivider, null), React.createElement("div", {
    className: styles.label
  }, React.createElement(SelectLabel, {
    text: props.text,
    indentLevel: props.indentLevel
  })));
};
SelectSection.defaultProps = {
  indentLevel: 0
};